<template>
    <dashboard>
        <row>
            <panel>
                <h3 slot="title">Attending Students</h3>
                <template slot="buttons">
                    <app-button size="small" @click="showAddStudent = true">Add Student</app-button>
                </template>

                <student-table
                    :items="students"
                    :sort-by="sort_by"
                    :attendable="event"
                    :columns="['first_name','last_name','email','attendance']"
                    attendable-type="event"
                    @sort-change="sortChange">
                    <template slot="actions">
                        <el-table-column label="Actions" width="150px" align="right">
                            <template slot-scope="scope">
                                <app-tooltip effect="dark" content="Remove From Event" placement="top-end">
                                    <app-button
                                        type="danger"
                                        size="mini"
                                        icon="icon-delete"
                                        @click.stop="handleRemove(scope.$index, scope.row)">
                                        <span class="visuallyhidden">Remove Student From Event</span>
                                    </app-button>
                                </app-tooltip>
                            </template>
                        </el-table-column>
                    </template>
                </student-table>

                <pagination
                    :current-page="page"
                    :page-size="per_page"
                    :total="total"
                    layout="prev, pager, next, total, sizes"
                    @current-change="pageChange"
                    @size-change="sizeChange"/>
            </panel>
        </row>

        <modal v-model="showAddStudent">
            <event-add-student :event="event" @reload="getStudents(getParameters())"/>
        </modal>
    </dashboard>
</template>

<script>
import table from '@/mixins/table'

import EventAddStudent from './EventAddStudent'
import StudentTable from '../Student/StudentTable'
import Student from '@/store/models/Student'

export default {
    name: 'page-event-detail-students',
    components: {
        EventAddStudent,
        StudentTable
    },
    mixins: [table],
    props: ['event'],
    data() {
        return {
            showAddStudent: false,
            relation: 'attending',
            tableParamKeys: ['relation_uuid', 'relation'],
            studentIds: [],
            total: 0
        }
    },
    computed: {
        eventAttendanceQuery() {
            return `attendance(
                uuid: "${this.event.uuid}", 
                type: "event", 
                start_date: "${this.event.date}",
                end_date: "${this.event.date}"
            ) {
                id
                attendable_id
                attendable_type
                status
                lock
                enter
                overrides {
                    user {
                        first_name
                        last_name
                    }
                    old_status
                }
            }`
        },
        relation_uuid() {
            return this.event.uuid
        },
        students() { 
            return Student.query()
                .with('attendance', (query) => {
                    query.where('attendable_type', 'event')
                        .where('attendable_id', this.event.id)
                })
                .with('attendance.overrides')
                .whereIdIn(this.studentIds)
                .get() 
        }
    },
    mounted() {
        this.getStudents(this.getParameters())
    },
    methods: {
        getStudents(params) {
            Student.$fetch({
                graphql: 'relation',
                variables: params,
                style: { 
                    extra: this.eventAttendanceQuery 
                }
            }).then(({ data, raw }) => {
                this.studentIds = data.map((item) => item.id)
                this.total = raw.total
            })
        },
        navigateToStudentDetail(student) {
            this.$router.push({
                name: 'students.detail',
                params: { uuid: student.uuid }
            })
        },
        paramsChanged(params) {
            this.getStudents(Object.assign(params, { extra: this.eventAttendanceQuery }))
        },
        addNewStudent() {
            this.showAddStudent = true
        },
        stateChange(state) {
            let params = this.getParameters()
            params.state = state
            this.setParameters(params)
        },
        handleRemove(inded, row) {
            this.event.$detach(
                row.id, 'students', 'removeStudentFromEvent', true
            )
                .then(() => {
                    this.getStudents(this.getParameters())
                })
        }
    }
}
</script>

<style lang="stylus"></style>
